export const DATA_SYNC_PREVIEW_KEY = 'dataSyncPreview';
